// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__1L-Iz","textarea":"TextArea_textarea__9FMhW"};